import { useHomePageStore } from "@/stores/HomePage";
import { type RouteLocationNormalized } from 'vue-router';

const {
	setShowAllHome
} = useHomePageStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		setShowAllHome(to.query.type as string);
	}
});